import React from 'react';
import { ApolloProvider } from 'react-apollo';
import type { Environment } from 'react-relay';
import { RelayEnvironmentProvider } from 'react-relay';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import type { ApolloClient } from '@confluence/apollo-relay-interop/entry-points/apolloTypes.ts';

import { getRelayEnvironment } from './relayEnvironment.ts';

interface Props {
	/**
	 * The Apollo client to use.
	 */
	client: ApolloClient<any>;
	/**
	 * The relay environment to use. If not provided, the default relay environment will be used. see {@link getRelayEnvironment}.
	 */
	relayEnvironment?: Environment;
	/**
	 * The children to render.
	 */
	children: React.ReactNode;
}

export const GraphqlProvider = ({
	client,
	relayEnvironment,
	children,
}: Props): React.JSX.Element => {
	return (
		<RelayEnvironmentProvider environment={relayEnvironment || getRelayEnvironment()}>
			<ApolloProvider client={client}>{children}</ApolloProvider>
		</RelayEnvironmentProvider>
	);
};
